import { useContext } from 'react';

import { UserListContext } from './user-list-provider';

export function useUserList() {
  const context = useContext(UserListContext);

  if (!context) {
    throw new Error('useUserList must be used within a UserListProvider');
  }

  return context;
}
